import { apiClient } from '@app/lib'
import { type SugarAttestationPeriod } from '@app/types'
import { useQuery } from '@tanstack/react-query'
import { useSession } from 'next-auth/react'

export const useAttestationPeriod = (attestationPeriodId?: string | null) => {
  const session = useSession()

  return useQuery({
    enabled: session.status === 'authenticated' && !!attestationPeriodId,
    queryKey: ['attestationPeriods', { attestationPeriodId }],
    queryFn: async () => {
      const { data } = await apiClient.get<SugarAttestationPeriod>(`/api/attestation-periods/${attestationPeriodId}`, {
        timeout: 60_000 // 1 minute
      })

      return data
    }
  })
}
